import _ from 'lodash'
import {IDataSource} from '.'
import {readAnyLines} from '@/utils/files'

export function localFileSource<T extends {file: File}>(args: T): IDataSource<T> {
  const {file} = args

  return {
    sourceID: 'localFile',
    key: `${file.name}-${file.size}`,
    args,
    fetch: async () => {
      const data = await readAnyLines(file)
      if (!data) return
      return data
    },
  }
}
